import {makeStyles} from '@material-ui/core/styles';

export default() =>{

    const useStyles = makeStyles ({
      main:{
        fontSize:"13px"
      },
 
        header: {
          padding: "20px !important",
          FlexDirection: "row",
          marginTop: "px",
          TextAlign: "rigt",
          borderBottom: "1px solid #CCCCCC;",
          paddingBottom: "10px",
          
        },
        additem: {
          display: 'flex',
          justifyContent: 'space-between'
        },
        buttonright:{
          float: "right"
        },
        button:{
          paddingRight: "50px",
          paddingLeft: "50px",
          marginRight: "20px",
          textTransform: 'capitalize',
          fontWeight: 'bold',
          letterSpacing: 0
        },
        body:{
          padding: "20px"
        },
        labeltext:{
          display: "flex",
        PaddingTop: "20px"
        },
        column1:{
          paddingRight: "30px"
        },
        column2:{
          paddingLeft: "25px"
        },
        custname:{
          background: "#f2f2f2",
          width: "600px",
          height: "30px",
          border: "none",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px",
          color:"#112B42"
        },
        invoiceno:{
          background: "#f2f2f2",
          width: "285px",
          height: "30px",
          border: "none",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px"
        },
        calendarposition:{
          position:"relative",
        },
        date:{
          background:"#f2f2f2",
          marginTop:"10px",
          width:"285px",
          height:"30px",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",

        },
        calendaricon:{
          position:"absolute",
          right:"15px",
          top:"15px",
          background:"#f2f2f2",
          borderBottom:"3px solid #f2f2f2",
          borderTop:"3px solid #f2f2f2",
          width:"15px"

        },
        billaddress:{
          background: "#f2f2f2",
          width: "600px",
          height: "110px",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px"
        },
        editaddress:{
          position: "relative"
        },
        editicon:{
          position: "absolute",
          top: "15px",
          right: "10px",
          cursor:"pointer",
          textTransform:"capitalize",
          color:"#0179E4",
          paddingLeft:"30px"
      
          

      
        },
        righttextfield:{
          background: "#f2f2f2",
          width: "600px",
          height: "30px",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px"
        },
        paymode:{
          background: "#f2f2f2",
          width: "235px",
          height: "30px",
          border: "none",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px"
        },
        label:{
          color: "#112B42"
        },
        underline:{
          background: "#f2f2f2",
          width: "285px",
          height: "30px",
          borderLeft: "10px solid #f2f2f2",
          borderRight: "10px solid #f2f2f2",
          marginBottom: "20px",
          marginTop : "10px",
          cursor:"pointer",
          "&&&:before":{ borderBottom: "none"}
        },
        itemdrop:{
            background: "white",
            width: "250px",
            height: "30px",
            border: "none",
            marginRight:"-100px",
            color:"#112B42"
          },
        deletecell:{
            
            border: "none"
        },
        subtotal:{
            float:"right",
            width:"30%",
            marginRight:"35px"
        },
        tablehead:{
            
            fontWeight:"bold",
            border: "none"
        },
        tablebody:{
            border: "none",
        },
        tablefoot:{
          background:"#f0f0f0",
          fontSize:"18px",
          fontWeight:"bold",
          color: "#112B42",
          height:"45px",
          paddingTop:"0px"
      },
      });
      return useStyles();
}